(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-logo-weights"] && !Shopify.designMode) return;
  try {
    
(() => {
 const initialize = root => {
 if (!root || root.dataset.ready) return;
 root.dataset.ready = 'true';
 const finishes = JSON.parse(root.querySelector('[data-kw-finishes]').textContent);
 root.querySelectorAll('[data-finish]').forEach(button => button.addEventListener('click', () => {
  const finish = finishes[Number(button.dataset.finish)];
  const video = root.querySelector('#kw-finish-video');
  root.querySelectorAll('[data-finish]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
  root.querySelector('#kw-finish-name').textContent = finish.name;
  root.querySelector('#kw-finish-description').textContent = finish.description;
  video.pause();
  video.poster = finish.poster;
  video.setAttribute('aria-label', finish.ariaLabel);
  video.querySelector('source').src = finish.url;
  video.load();
 }));
 root.querySelectorAll('[data-interest]').forEach(link => link.addEventListener('click', () => {
  const input = [...root.querySelectorAll('[data-interest-input]')].find(el => el.dataset.interestInput === link.dataset.interest);
  if (input) input.checked = true;
  if (link.hasAttribute('data-finish-inquiry')) {
   const selected = root.querySelector('[data-finish][aria-pressed="true"]');
   const field = root.querySelector('[data-selected-finish]');
   field.value = finishes[Number(selected.dataset.finish)].name;
   field.disabled = false;
   root.querySelector('[data-selected-finish-wrap]').hidden = false;
  }
 }));
 };
 initialize(document.getElementById('kw-page'));
 document.addEventListener('shopify:section:load', event => initialize(event.target.querySelector('#kw-page')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kensui-contact"] && !Shopify.designMode) return;
  try {
    
  function initializeKensuiContact(root) {
    if (!root || root.hasAttribute('data-enhanced')) return;
    root.setAttribute('data-enhanced', '');
    const topic = root.querySelector('[data-kct-topic-select]');
    const hint = root.querySelector('[data-kct-hint]');
    const topics = { 'Order or delivery':'order', 'Product advice':'product', 'Returns or exchanges':'returns', 'Wholesale or business':'business' };
    function updateHint() {
      if (topic && hint) hint.textContent = hint.dataset[topics[topic.value] || 'general'];
    }
    if (topic) {
      topic.addEventListener('change', updateHint);
      updateHint();
      root.querySelectorAll('[data-kct-topic]').forEach(link => link.addEventListener('click', () => {
        topic.value = link.dataset.kctTopic;
        updateHint();
        requestAnimationFrame(() => topic.focus({preventScroll:true}));
      }));
    }
    const status = root.querySelector('[data-kct-status]');
    if (status) status.focus();
  }
  document.querySelectorAll('[data-kct]').forEach(initializeKensuiContact);
  document.addEventListener('shopify:section:load', event => initializeKensuiContact(event.target.querySelector('[data-kct]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kensui-performance-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const observe = (root) => {
      root.querySelectorAll('[data-kph-motion] .kph__press').forEach((press) => {
        if (press.dataset.revealBound) return;
        press.dataset.revealBound = 'true';
        if (!('IntersectionObserver' in window)) return;
        const observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            press.classList.add('is-revealed');
            observer.disconnect();
          }
        }, { threshold: .25 });
        observer.observe(press);
      });
    };
    observe(document);
    document.addEventListener('shopify:section:load', (event) => observe(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kensui-shop-all"] && !Shopify.designMode) return;
  try {
    
  function initializeKensuiCatalog(root) {
    if (!root || root.hasAttribute('data-enhanced')) return;
    const form = root.querySelector('[data-ksa-controls]');
    const sort = root.querySelector('[data-ksa-sort]');
    if (form && sort) sort.addEventListener('change', () => form.requestSubmit());
    root.querySelectorAll('.ksa-quick').forEach(link => {
      const destination = new URL(link.href);
      const current = new URL(window.location.href);
      current.searchParams.set('sort_by', destination.searchParams.get('sort_by'));
      current.searchParams.delete('page');
      current.hash = 'ksa-catalog';
      link.href = current.toString();
    });
    root.setAttribute('data-enhanced', '');
    root.querySelectorAll('.ksa-filter').forEach(details => {
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          details.open = false;
          details.querySelector('summary').focus();
        }
      });
    });
  }
  document.querySelectorAll('[data-ksa]').forEach(initializeKensuiCatalog);
  document.addEventListener('shopify:section:load', event => initializeKensuiCatalog(event.target.querySelector('[data-ksa]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kensui-trusted-athletes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kensui-athlete-gallery')) {
    customElements.define('kensui-athlete-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.kta__track');
        this.buttons = this.querySelectorAll('.kta__arrow');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.buttons.forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.direction)), options));
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.behavior() });
          else this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.kta__card');
          if (card) this.track.scrollTo({ left: card.offsetLeft - this.track.firstElementChild.offsetLeft, behavior: 'auto' });
        }, options);
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
      behavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      move(direction) {
        const card = this.track.firstElementChild;
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        this.track.scrollBy({ left: direction * step, behavior: this.behavior() });
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.buttons[0].disabled = this.track.scrollLeft <= 2;
        this.buttons[1].disabled = this.track.scrollLeft >= max - 2;
        const fraction = Math.min(1, this.track.clientWidth / this.track.scrollWidth);
        const progress = max > 0 ? Math.max(0, Math.min(1, this.track.scrollLeft / max)) : 0;
        this.style.setProperty('--kta-progress-width', `${fraction * 100}%`);
        this.style.setProperty('--kta-progress-offset', `${progress * (1 - fraction) / fraction * 100}%`);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kensui-woody-product"]) return;
  try {
    
  function initWoody(root) {
    if (!root || root.dataset.woodyReady) return;
    root.dataset.woodyReady = 'true';
    const slides = [...root.querySelectorAll('[data-woody-slide]')];
    const thumbs = [...root.querySelectorAll('[data-woody-thumb]')];
    const stage = root.querySelector('[data-woody-stage]');
    const rail = root.querySelector('[data-woody-thumbs]');
    const counter = root.querySelector('[data-woody-counter]');
    let active = Math.max(0, slides.findIndex(slide => !slide.hidden));
    function showImage(index) {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== active; });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === active)));
      if (counter) counter.textContent = `${active + 1} / ${slides.length}`;
      const thumb = thumbs[active];
      if (thumb && rail) {
        const left = thumb.offsetLeft - rail.offsetLeft;
        if (left < rail.scrollLeft || left + thumb.offsetWidth > rail.scrollLeft + rail.clientWidth) rail.scrollTo({left:left - rail.clientWidth / 2 + thumb.offsetWidth / 2,behavior:'auto'});
      }
    }
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
    root.querySelectorAll('[data-woody-step]').forEach(button => button.addEventListener('click', () => showImage(active + Number(button.dataset.woodyStep))));
    let touchStart = null;
    stage.addEventListener('touchstart', event => { touchStart = {x:event.touches[0].clientX,y:event.touches[0].clientY}; }, {passive:true});
    stage.addEventListener('touchend', event => {
      if (!touchStart) return;
      const dx = event.changedTouches[0].clientX - touchStart.x;
      const dy = event.changedTouches[0].clientY - touchStart.y;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) showImage(active + (dx < 0 ? 1 : -1));
      touchStart = null;
    }, {passive:true});
    const select = root.querySelector('[data-woody-select]');
    const options = [...root.querySelectorAll('[data-woody-variant]')];
    const add = root.querySelector('[data-woody-add]');
    const stock = root.querySelector('[data-woody-stock]');
    function updateVariant(id, updateUrl) {
      const variant = [...select.options].find(option => option.value === String(id));
      if (!variant) return;
      select.value = variant.value;
      const available = variant.dataset.available === 'true';
      window.KensuiStockDelivery?.update(root, variant.value);
      root.dataset.woodyAvailable = String(available);
      options.forEach(button => { const chosen = button.dataset.woodyVariant === variant.value; button.classList.toggle('on', chosen); button.setAttribute('aria-pressed', String(chosen)); });
      root.querySelector('[data-woody-price]').innerHTML = variant.dataset.price;
      const compare = root.querySelector('[data-woody-compare]');
      compare.innerHTML = variant.dataset.compare || '';
      compare.hidden = !variant.dataset.compare;
      add.disabled = !available;
      add.textContent = available ? add.dataset.addLabel + ' ↗' : add.dataset.soldLabel;
      stock.textContent = available ? stock.dataset.availableLabel : stock.dataset.unavailableLabel;
      if (updateUrl && variant.dataset.imageId) { const imageIndex = slides.findIndex(slide => slide.dataset.woodyImageId === variant.dataset.imageId); if (imageIndex >= 0) showImage(imageIndex); }
      if (updateUrl) { const url = new URL(window.location.href); url.searchParams.set('variant',variant.value); window.history.replaceState({},'',url); }
    }
    options.forEach(button => button.addEventListener('click', () => { updateVariant(button.dataset.woodyVariant, true); select.dispatchEvent(new Event('change',{bubbles:true})); }));
    select.addEventListener('change', () => updateVariant(select.value, true));
    showImage(active);
    updateVariant(select.value, false);
  }
  document.querySelectorAll('[data-woody-section]').forEach(initWoody);
  document.addEventListener('shopify:section:load', event => initWoody(event.target.querySelector('[data-woody-section]')));

  } catch(e) { console.error(e); }
})();
})();
